"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = encodeOSC;

var _oscJs = _interopRequireDefault(require("osc-js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// parse sysex to OSC
function encodeOSC(data) {
  // unpack OSC chunks into buffer
  let oscBuffer = decodeSysex(data);
  const oscmsg = new _oscJs.default.Message();
  oscmsg.unpack(new DataView(oscBuffer.buffer));
  return oscmsg;
}

function decodeSysex(message) {
  // Names for bits
  const BIT_00 = 1,
        BIT_01 = 1 << 1,
        BIT_02 = 1 << 2,
        BIT_03 = 1 << 3,
        BIT_04 = 1 << 4,
        BIT_05 = 1 << 5,
        BIT_06 = 1 << 6,
        BIT_07 = 1 << 7; // ignore sysex start, device identity, sysex close, resulting in only message payload

  const sysexPayload = message.slice(9, -1),
        messageLength = sysexPayload.length;
  let oscBufferIndex = 0,
      messageBuffer = [];

  for (let i = 0; i < messageLength; i += 5) {
    // 5th byte low nibble contains the high bits of the previous 4 bytes
    let msbits = sysexPayload[i + 4];
    messageBuffer[oscBufferIndex] = sysexPayload[i];
    if (msbits & BIT_00) messageBuffer[oscBufferIndex] |= BIT_07;
    messageBuffer[oscBufferIndex + 1] = sysexPayload[i + 1];
    if (msbits & BIT_01) messageBuffer[oscBufferIndex + 1] |= BIT_07;
    messageBuffer[oscBufferIndex + 2] = sysexPayload[i + 2];
    if (msbits & BIT_02) messageBuffer[oscBufferIndex + 2] |= BIT_07;
    messageBuffer[oscBufferIndex + 3] = sysexPayload[i + 3];
    if (msbits & BIT_03) messageBuffer[oscBufferIndex + 3] |= BIT_07;
    oscBufferIndex += 4;
  }

  return new Uint8Array(messageBuffer);
}